// Generated by scripts/benchmarks.mjs from terragov/archis-benchmarks@run/0.49.0
// (commit bd6b7027821bb70da06ab16aff738f5013595d0b). Do not edit: run `node scripts/benchmarks.mjs sync <version>`
// to move to another run, and `check` to prove this file matches the vendored one.

/** The public run every figure below is computed from. */
export const BENCHMARK_RUN = {
  "repository": "terragov/archis-benchmarks",
  "version": "0.49.0",
  "tag": "run/0.49.0",
  "commit": "bd6b7027821bb70da06ab16aff738f5013595d0b"
} as const

/** Cohort 5, from runs/0.49.0/fase_a. */
export const COHORT5_RUN = {
  "repos": 86,
  "hashStable": 86,
  "medianReduction": 76.8,
  "files": 425136,
  "symbols": 8163519,
  "incrementalEqual": 64,
  "incrementalDiffers": [
    "sql-server-samples"
  ],
  "notProbed": 21,
  "notProbedXml": 6,
  "notProbedNoSourceFile": 15,
  "unmeasured": [
    "azure-powershell"
  ]
} as const

/** The whitepaper's per-language table, cohort-5 languages only. */
export const COHORT5_LANGUAGE_RUN = [
  {
    "lang": "Swift",
    "repos": 14,
    "files": 28858,
    "symbols": 456929,
    "recall": 100
  },
  {
    "lang": "Dart",
    "repos": 9,
    "files": 34803,
    "symbols": 635698,
    "recall": null
  },
  {
    "lang": "Ruby",
    "repos": 27,
    "files": 37230,
    "symbols": 218075,
    "recall": 100
  },
  {
    "lang": "Elixir",
    "repos": 7,
    "files": 2272,
    "symbols": 44402,
    "recall": 100
  },
  {
    "lang": "Scala",
    "repos": 9,
    "files": 10366,
    "symbols": 405265,
    "recall": 100
  },
  {
    "lang": "Lua",
    "repos": 5,
    "files": 411,
    "symbols": 5233,
    "recall": 100
  },
  {
    "lang": "PowerShell",
    "repos": 17,
    "files": 2311,
    "symbols": 3408,
    "recall": null
  },
  {
    "lang": "Zig",
    "repos": 5,
    "files": 3331,
    "symbols": 184172,
    "recall": 100
  },
  {
    "lang": "SQL",
    "repos": 21,
    "files": 4382,
    "symbols": 15434,
    "recall": null
  },
  {
    "lang": "GraphQL",
    "repos": 4,
    "files": 1568,
    "symbols": 6463,
    "recall": 89
  },
  {
    "lang": "Groovy",
    "repos": 18,
    "files": 9932,
    "symbols": 80454,
    "recall": 98
  },
  {
    "lang": "XML",
    "repos": 43,
    "files": 13786,
    "symbols": 418934,
    "recall": 100
  },
  {
    "lang": "Dockerfile",
    "repos": 33,
    "files": 368,
    "symbols": 2246,
    "recall": 100
  },
  {
    "lang": "YAML",
    "repos": 82,
    "files": 26417,
    "symbols": 704830,
    "recall": 100
  },
  {
    "lang": "Protobuf",
    "repos": 14,
    "files": 8402,
    "symbols": 333295,
    "recall": 100
  }
] as const

/** Fase B symbol recall, from runs/0.49.0/fase_b/recall.json. */
export const FASE_B_RUN = {
  "repos": 111,
  "languages": 22,
  "strict": 98.6,
  "lenient": 99.2
} as const

/** Which file, field and aggregate each figure is. */
export const BENCHMARK_SOURCES = {
  "repos": "runs/0.49.0/fase_a/cohort5.json, count of rows (the repositories whose database the run kept)",
  "hashStable": "runs/0.49.0/fase_a/cohort5.json, hash_stable, count true",
  "medianReduction": "runs/0.49.0/fase_a/cohort5.json, reduction, median",
  "files": "runs/0.49.0/fase_a/cohort5_languages.json, languages[*].files, sum",
  "symbols": "runs/0.49.0/fase_a/cohort5_languages.json, languages[*].symbols, sum",
  "incremental": "runs/0.49.0/fase_a/cohort5.json, incremental_equiv, with the reason for each null from runs/0.49.0/fase_a/cohort5_languages.json verdicts[*].incremental_skip",
  "languageTable": "runs/0.49.0/fase_a/cohort5_languages.json (repos, files, symbols); runs/0.49.0/fase_b/recall.json (recall, mean per language)",
  "faseB": "runs/0.49.0/fase_b/recall.json, recall_strict_path and recall, mean over the rows with a comparable oracle"
} as const
